import required from "./required"

/**
 * Rule to check if the field has no value
 */
export default {
    name     : 'nullable',
    validate : (value, data, parameters) => !required.validate(value, data, parameters),
    message  : (field, data, parameters) => `The field ${field} must be empty or match additional validation`
}